<div class="d-flex justify-content-start mb-4">
    <h6>Totale importo disinvestimenti: <span class="status-ko">{{ totalDivestmentAmount | currency:'EUR' }}</span></h6>
</div>
<ng-container *ngIf="showFunds">
    <app-assets-table [assets]="assets" [form]="form" [tableKeys]="tableKeys" [divestedFunds]="divestedFunds" [isReadOnly]="isReadOnly"></app-assets-table>
</ng-container>